





































































































import { reactive, defineComponent, watch } from '@vue/composition-api';
import { Size } from '@/models/entities/Size';

interface State {
  sizeToEdit: Size;
}

interface Props {
  size: Size;
  onSave: Function;
  onCancel: Function;
}

const Component = defineComponent({
  name: 'SizeDialogContent',

  props: {
    size: Object,
    onSave: Function,
    onCancel: Function,
  },

  setup(props: Props) {
    const state: State = reactive({
      sizeToEdit: props.size,
    });

    watch(
      () => props.size,
      (newSize: Size) => (state.sizeToEdit = newSize),
    );

    return {
      state,
    };
  },
});

export default Component;
